// 按页面划分
export default {
    // 公共页面
    common: {
        title: "داتا مول",
        pull_refresh: 'اسحب للأسفل للتحديث',
        release_refresh: 'الافراج عن التحديث',
        refresh_loading: 'تحميل…',
        footer_text: 'الخدمات مقدمة من قبل Ucloudlink (ناسDAQ: UCL)'
    },
    home: {
        input_placeholder: 'البحث في البلد/المنطقة',
        my_flow: 'بياناتي',
        charge_code: 'رمز القسيمة',
        coupons:'كوبونات',
        local_package: 'البيانات المحلية',
        more: 'أكثر',
        popular_destination: 'البلد/المنطقة',
        buy_now:'اشتري الآن',
        package_useing: 'نشط',
        unused: 'غير نشط',
        download_app: 'تحميل التطبيق',
        enter_the_mall_list: 'اذهب إلى المول',
        no_data: 'لا توجد بيانات حتى الآن',
        no_data_available: 'لا توجد بيانات متاحة',
        copy_success: 'نسخ ناجح',
        copy_fail: 'فشل النسخ',
        meritsTitle: 'ما هي الميزات؟',
        merits1: 'لا حاجة لـ SIM & لا رسوم شهرية',
        merits2: 'متكامل مع أفضل 2-3 شركات إتصال لتبديل الشبكة التلقائي',
        go_buy: 'يشتري',
        instant_savings: 'وفر',
        expires_in: 'ينتهي خلال',
        download_app_tips: "حمّل التطبيق لمزيد من العروض والمميزات"
    },
    packages: {
        sub_title: {
            us: 'باستثناء غوام، سايبان',
            it: 'بما في ذلك مدينة الفاتيكان، سان مارينو',
            va: 'بما في ذلك إيطاليا وسان مارينو',
            sm: 'بما في ذلك إيطاليا، مدينة الفاتيكان',
            ma: 'بما في ذلك الصحراء الغربية',
            eh: 'بما في ذلك المغرب',
            ch: 'بما في ذلك ليختنشتاين',
            li: 'بما في ذلك سويسرا',
            fr: 'بما في ذلك موناكو',
            mc: 'بما في ذلك فرنسا',
            fi: 'بما في ذلك جزر آلاند',
            ax: 'بما في ذلك فنلندا',
            gu: 'بما في ذلك جزر ماريانا الشمالية',
            mp: 'بما في ذلك غوام'
        },
        unlimited_packages: 'باقة بيانات غير محدودة',
        normal_packages: 'حزمة البيانات العادية',
        multi_region_packages: 'متعدد المناطق',
        regional_data: 'البيانات الإقليمية',
        high_speed_text: 'بيانات عالية السرعة',
        infiniteFlow: 'بيانات غير محدودة',
        unLimitData: 'غير محدود',
        high_speed_text_year: 'سرعة عالية / النائب',
        package_list: 'قائمة الحزم',
        special_offer: 'مبيعات',
        first_month: 'شهر أول',
        periodUnit: {
            day: 'أيام)',
            month: 'شهر',
            hour: 'ساعات)',
            year: 'سنة',
        },
        periodUnits: {
            day: 'أيام)',
            month: 'شهور',
            hour: 'ساعات)',
            year: 'سنة',
        },
        periodUnitSimp: {
            day: 'د',
            month: 'ل',
            hour: 'ح',
            year: 'ال'
        },
        periodUnitMonthly:'شهري',
        periodUnitsSimp: {
            day: 'د',
            month: 'ل',
            hour: 'ح',
            year: 'ال'
        },
        unlimited_good_name: {
            day: 'تذكرة يومية',
            month: 'تذكرة شهرية',
            year: 'تذكرة سنوية'
        },
        continuousMonth: "أشهر مستمرة",
        continuousDay: "أيام مستمرة",
        continuousYear: "سنوات مستمرة",

        day_invalid: 'تنتهي صلاحيته في اليوم الحالي',
        month_invalid: 'تنتهي في الشهر الحالي',
        immediate_valid: 'فعالة على الفور',
        tomorrow_day_valid: 'يسري مفعوله من اليوم التالي',
        tomorrow_month_valid: 'ساري المفعول اعتبارا من الشهر المقبل',

        // detail page
        detail: {
            cell_flow: 'بيانات',
            cell_period: 'صحة',
            buy_quantity: 'كمية',
            use_area: 'التغطية',
            use_intro: 'الشروط والأحكام',
            buy_btn: 'طلب',
            pay: 'يدفع',
            buy_tips: 'لديك باقة %@packageName قيد الاستخدام. هل تريد شراء هذه الباقة؟',
            haveOrderTips: "لقد أنشأت طلبًا قيد الدفع. انقر تأكيد لانتقال إلى صفحة بياناتي للعرض！"
        },

        // confirm page
        confirm: {
            title: 'تأكيد الطلب',
            real_pay_amount: 'المبلغ المدفوع',
            online_payment: 'الدفع عبر الإنترنت',
            create_order_error: 'فشل الإعداد'
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: 'جارٍ الحصول على حالة الطلب…',
            buy_success: 'اكتمل الطلب',
            buy_pending: 'في انتظار التأكيد',
            buy_pending_tip: 'الدفع قيد المعالجة...إذا لم يتم تحويل الدفع خلال 10 دقائق، فيرجى الاتصال بنا للحصول على الدعم.',
            get_payment_info_fail: 'فشل الحصول على معلومات الدفع',
            cell_package: 'طَرد',
            cell_buy_amount: 'المجموع الفرعي',
            cell_real_amount: 'المبلغ المدفوع',
            go_to_order_btn: 'اذهب إلى الحزمة الخاصة بي',
            back_home: 'العودة إلى المنزل',
            back_mall: 'العودة إلى المول',
            ordersn_empty: 'لا يمكن أن يكون رقم الطلب فارغًا',
            order_search_error: 'خطأ غير متوقع',
            goodsName: 'اسم المنتج'
        },

        //fail page
        fail: {
            payment_fail: 'فشل الدفع',
            back_home: 'العودة إلى المنزل'
        }
    },
    CountryGroup: {
        title: "البلد/المنطقة",
        placeholder: "ابحث عن البلد أو المنطقة",
        clear: "واضح",
        history: "سجل البحث "
    },
    PromotionCode: {
        verification: {
            title: 'رمز القسيمة',
            minititle: 'رمز القسيمة',
            input: 'الرجاء إدخال رمز التعبئة',
            explain: 'نصائح: المس زر المسح الضوئي في الجزء العلوي الأيمن لمسح رمز الاستجابة السريعة لبطاقة القسيمة، أو أدخل رمز القسيمة يدويًا (حساس لحالة الأحرف) إذا لم يعمل.',
            submit: 'يُقدِّم',
            exchange: 'يسترد',
            cancel: 'يلغي',
            Inquiry: "هل أنت متأكد من التبادل",
            ErrorCode: 'خطأ في رمز إعادة الشحن',
        },
        recharge_success: {
            package: 'طَرد',
            content: 'تم الاسترداد بنجاح',
            back: 'العودة إلى مركز التسوق',
            view_packets: 'اذهب إلى الحزمة الخاصة بي'
        }
    },
    order: {
        state: {
            inUse: 'تفعيلها',
            isFirst: 'ذات الأولوية',
            toFirst: 'تعيين الأولوية',
            inactive: 'معطل'
        },
        periodUnits: {
            minute: 'دقائق)',
            hour: 'ساعات)',
            day: 'أيام)',
            month: 'شهور',
        },
        useIntro: {
            tip1: 'تتمتع باقة البيانات غير المحدودة بأولوية أعلى من باقة البيانات المجمعة.',
            tip2: 'ستعتمد أولوية الاستخدام على تاريخ الشراء لنفس نوع الباقة، أي أنه سيتم استخدام الباقة ذات تاريخ الشراء الأقدم أولاً، بينما تكون أولوية الباقات ذات المنطقة الواحدة أعلى من الباقات الإقليمية.',
            tip3: 'يمكنك أيضًا ضبط أولوية استخدام الحزم من نفس النوع يدويًا.'
        },
        myFlow: 'بياناتي',
        remainingFlow: 'البيانات المتبقية',
        remainingTime: 'اليسار صالح',
        remainingHighFlow: 'البيانات عالية السرعة اليسار',
        validPeriod: 'صحة',
        noneFlow: 'لا توجد حزمة بيانات',
        noneFlowTip: 'يرجى شراء باقة البيانات والاستمتاع بالشبكة عالية الجودة',
        buyPackFlow: 'اشترِ الحزم',
        checkInvalidFlow: 'التحقق من حزمة البيانات منتهية الصلاحية',
        orderList: {
            "title": "أوامري",
            "amount_paid": "المجموع",
            "device": "الجهاز المملوك",
            "order_details": "تفاصيل الطلب",
            "total_amont": "المجموع الفرعي",
            "orderSN": "رقم الطلب.",
            "createTime": "وقت الخلق",
            "cancelTime": "وقت مغلق",
            "payTime": "وقت الطلب",
            "unsubTime": "الوقت الملغى",
            "payMethod": "طريقة الدفع",
            "thirdSN": "رقم المعاملة",
            "delete": "يمسح",
            "cancel": "إلغاء الطلب",
            "unsub": "استرداد",
            "goto_cancel": "هل تريد إلغاء الطلب؟",
            "goto_unsubscribe": "هل تريد إلغاء الاشتراك في الطلب؟",
            "delete_Tips": "لا يمكن استئناف الطلب بعد حذفه، وبالتالي لا يمكن معالجة مشاكل ما بعد الخدمة.هل أنت متأكد من حذفه؟",
            "status_success": "مكتمل",
            "status_pending": "غير مدفوعة الأجر",
            "status_cancel": "مغلق",
            "status_unsub": "تم الإلغاء",
            "payMethod_stripe": "بطاقة الائتمان"
          },
    },
    registerlogin: { 
        create_account_tip:"إنشاء حساب ، ابدأ خبرة حصرية",
        select_country_tip:"استخدام الجهاز البلد/المنطقة",
        email_name: "بريد",
        phone_name: "هاتف",
        email_address: "عنوان البريد الإلكتروني",
        password: "كلمة المرور",
        country: "دولة",
        select_country: "اختر بلد",
        cancel: "يلغي",
        confirm: "بالتأكيد",
        please_enter: "الرجاء إدخال 6-20 أحرف (مزيج من الحروف أو الأرقام أو الرموز)",
        select_country_tips: "اختيار البلد هو لعرض الحزم المحلية. لا يمكن تغييره بعد التسجيل. الرجاء تأكيد!",
        global_roaming: "رمز المجال الدولي",
        phone_number: "رقم التليفون",
        agree: "يوافق",
        user_agreement: "اتفاق المستخدم",
        and: "و",
        privacy_policy: "سياسة الخصوصية",
        register_login: "اشترك أو تسجيل الدخول",
        login_error: "عدد عمليات تسجيل الدخول متكررة للغاية ، يرجى المحاولة مرة أخرى لاحقًا!",
        register_error: "عدد التسجيلات متكررة للغاية ، يرجى المحاولة مرة أخرى لاحقًا!",
        forgot_pwd: "ننسى كلمة المرور",
        app_tips: "قم بتسجيل الدخول إلى التطبيق باستخدام هذا الحساب بعد تنزيله للوصول إلى المزيد من الميزات.",
        download_app: "انتقل لتنزيل التطبيق",
        rememberPwd: "تذكر كلمة المرور",
        third_login: 'تواصل مع',
        agreement_tips: "يرجى التحقق من مربع اتفاقية المستخدم وسياسة الخصوصية",
        selectCountry_tips: "يرجى ملاحظة أن البلد المسجل سيؤثر بشكل مباشر على طرق الدفع والعملات التالية، يرجى الاختيار وفقًا لاحتياجاتك.",
        login_error_cancel: "العميل ألغى تسجيل الدخول",
        login_error_auth: "يرجى السماح بالنوافذ المنبثقة من إعدادات المتصفح",
        device_tips: "الجهاز في انتظار التنشيط. سنقوم بمعالجته خلال 24 ساعة."
    },
    forgotPwd: {
        forgot_pwd: "ننسى كلمة المرور",
        email_address: "عنوان البريد الإلكتروني",
        next: "التالي",
        email_has_been_sent: "لقد أرسلنا بريدًا إلكترونيًا إلى %@email الإلكتروني. يرجى النقر على الرابط واتبع الخطوات لاسترداد كلمة المرور الخاصة بك.",
        have_retrieved_it: "لقد وجدت ذلك",
        unable_to_receive_email: "لا يمكنك تلقي البريد الإلكتروني؟ يرجى التحقق مما إذا كانت هناك رسائل بريد إلكتروني من %@email الإلكتروني تحت البريد العشوائي الخاص بك ودليل البريد المحذوف",
        or: "أو",
        resend: "إعادة الالتحاق",
        global_roaming: "رمز المجال الدولي",
        phone_number: "رقم التليفون",
        verification_code_has_been_sent: "لقد أرسلنا رمز التحقق إلى:",
        verification_code: "رمز التحقق",
        no_verification_code_received: "لم يتلق رمز التحقق؟",
        please_enter: "الرجاء إدخال 6-20 أحرف (مزيج من الحروف أو الأرقام أو الرموز)",
        reset_password: "إعادة تعيين كلمة المرور",
        reset_successful: "إعادة تعيين بنجاح"
    },
    coupons: {
        coupons_name: "كوبونات",
        no_coupons: "لا كوبونات حتى الآن",
        no_data: "لا توجد بيانات حتى الآن",
        applicable_to_the_following: "القسائم مناسبة لحزمة البيانات التالية"
    },
    digital: {
        title: "جهاز SN",
        purchased: "مشترياتي",
        viewAll: "أكثر",
        skinStore: "متجر المنتجات",
        completed: "تم شراؤها",
        goBuy: "يشتري",
        order: {
            title: "الطلبات المشتراة"
        },
        detail: {
            describe: "وصف"
        }
    },
    viewPL: {
        other: 'آخر'
    },
    invalidFlow: {
        stateName: 'حالة',
        state: {
            NOT_ACTIVATED: "معطل",
            IN_USING: "متاح",
            USE_END: "مرهق",
            EXPIRE: "منتهي الصلاحية",
            TRANSFER: "تحويل",
            UNSUBSCRIBE: "يلغي",
            VALID: "صالح",
            INVALID: "غير صالح",
            EXCHANGE_POINTS: "استبدال النقاط"
        },
        noneFlow: 'لا توجد حزمة بيانات منتهية الصلاحية',
        pageName: 'حزمة البيانات منتهية الصلاحية'
    },
    flowDetail: {
        title: 'تفاصيل البيانات',
        flow: 'بيانات',
        validTime: 'تفاصيل البيانات',
        invalidTime: 'صالحة حتى',
        coverage: 'التغطية',
        useIntro: 'الشروط والأحكام',
        purchaseTime: 'تم شراؤها في',
        subtotal: 'المجموع الفرعي',
        status: 'حالة',
        cancel: 'يلغي',
        buyAgain: 'شرائه مرة أخرى',
        validity: 'صحة',
        tip: 'يلاحظ',
        cancelTip: 'هل أنت متأكد أنك تريد استرداد هذه الحزمة؟',
        dataLeft: 'البيانات المتبقية'
    },
    netError: {
        try_again: 'حاول ثانية',
        net_error: 'لا توجد شبكة',
        try_again_desc: 'الرجاء التحقق من إعداد الشبكة والمحاولة مرة أخرى'
    },
    loadFail: {
        try_again: 'حاول ثانية',
        load_fail: 'فشل التحميل',
        load_fail_desc: 'فشل تحميل البيانات، يرجى المحاولة مرة أخرى',
        IMEI_Not_Exist: 'IMEI غير موجود، يرجى محاولة الدخول من المدخل الأيمن',
        Project_Not_Exist: 'يحدث خطأ. يرجى الاتصال بخدمة العملاء.(01)',
        commonError: 'يحدث خطأ. يرجى الاتصال بخدمة العملاء.',
    },
    settlement_Easy_and_convenient: "سهل ومريح",
    settlement_Great_deal: "كثيرا",
    settlement_Safe_and_secure: "آمنة ومأمونة",
    settlement_Autopay_service_regulation: "لائحة خدمة التلقائي",
    settlement_Read: "يقرأ",
    settlement_No_coupon: "لا القسيمة المتاحة",
    settlement_Subtotal: "نطاق فرعي",
    settlement_Coupon: "قسيمة",
    settlement_TOTAL: "المجموع",
    settlement_promotion_tip: "لا يمكن استخدام العرض الترويجي بالاقتران مع أي كوبونات",
    settlement_coupon_tip: "لا يمكن استخدام القسيمة بالاقتران مع أي عروض ترويجية أخرى",
    member_myFlow_noList: "لا توجد بيانات~",
    detail_se_content: "طريقة آمنة وسهلة ومريحة. يمكنك إلغاء الاشتراك في أي وقت",
    Enter_Promo_code: "رمز الترويج",
    Enter_Promo_Coupon:"كوبونات",
    settlement_Not_used_coupon:"القسيمة غير المستخدمة",
    settlement_Available_coupon:"متاح",
    settlement_Unavailable_coupon:"غير متاح",
    please_Enter_Promo_code: "الرجاء إدخال رمز الترويج",
    please_Select_Coupon_use: "الرجاء تحديد القسيمة التي تريد استخدامها",
    Buy_Now: "اشتري الآن",
    Dont_Use_Any: "لا تستخدم أي",
    settlement_confirm: "يتأكد",
    flowDetail_unsubscribe: "إلغاء الاشتراك",
    flowDetail_unsubscribed: "إلغاء الاشتراك",
    flowDetail_isCancelPackage: "إلغاء الاشتراك في هذه الحزمة؟",
    flowDetail_confirmAgreementUnsubscribe: "لا يمكن أن يكون لديك الكثير بعد إلغاء الاشتراك. هل أنت متأكد أنك تريد إلغاء الاشتراك؟",
    flowDetail_cancel: "يلغي",
    flowDetail_cancelSuccess: "إلغاء الاشتراك بنجاح",
    packages_detail_promotion: "ترقية",
    orderTips:{
        "iDay" : "يوم",
        "iDays" : "أيام",
        "iMonth" : "شهر",
        "iMonths" : "شهور",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol على الشراء الأول لك، دفع %@money/%@periodSymbol لاحقًا، يمكنك إلغاء الاشتراك في أي وقت",
        'Monthly_discount':"حفظ %@saveMoney كل  %@period! يمكنك إلغاء الاشتراك في أي وقت",
        'Ordinary_monthly_package':"طريقة آمنة وسهلة ومريحة. يمكنك إلغاء الاشتراك في أي وقت",
        "AlreadyPurchased":'آسف أنه يمكنك فقط الاشتراك في حزمة بيانات واحدة في الوقت الحالي. يرجى إلغاء الاشتراك من “%@” والاشتراك لاحقًا في أي حزمة تريدها بعد انتهاء صلاحيتها.',
        "Contract_recommendation_First":'<label>مع خدمة Autopay ، في الشراء الأول ، ادفع فقط</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">يمكنك إلغاء الاشتراك في أي وقت'
        +'<a class="btn">يشترك ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>مع خدمة الطيار الآلي ، ادفع فقط</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">يمكنك إلغاء الاشتراك في أي وقت'
        +'<a class="btn">يشترك ></a></p>',
        "Contract_recommendation_General":"<label>مع خدمة الطيار الآلي</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">طريقة آمنة وسهلة ومريحة. يمكنك إلغاء الاشتراك في أي وقت'
        +'<a href="javascript:;" class="btn">يشترك ></a></p>',
        'BanlanceDoubleCheck':'هل أنت متأكد أنك تريد أن تدفع بالتوازن؟',
    },
    feedback: {
        title: "تعليق",
        placeholder: "الرجاء إدخال البلد الذي ترغب في زيارته أو أي أسئلة أخرى ، وسنلبي احتياجاتك في أقرب وقت ممكن!",
        submit: "يُقدِّم",
        submit_success: "تم الإرسال بنجاح",
        other_opinions: "آراء أخرى"
    },
    view_country_input: 'الرجاء إدخال حسابك',
    select_package: {
        title: "اختر البيانات",
        allPackage: 'جميع البيانات',
        type: "نوع",
        flow: "بيانات",
        month_package: "خطة شهرية",
        flow_package: "حزمة بيانات",
        time: "مدة",
        period: "دورة",
        auto_debit: "معلومات الخصم التلقائي",
        auto_subscribe: "تجديد تلقائي",
        detail: "تفاصيل البيانات",
        carrier: "شركات الاتصال المدعومة",
        country: "قائمة الدول المغطاة",
        notice: "دليل الشراء"
      }  
}